export function swapListItem(items, id, direction) {
  const index = items.findIndex((item) => item.id === id);
  const target = direction === 'up' ? index - 1 : index + 1;
  if (index < 0 || target < 0 || target >= items.length) {
    return items;
  }
  const next = items.slice();
  const moved = next[index];
  next[index] = next[target];
  next[target] = moved;
  return next;
}
